import { useState } from 'react';
import { categories } from '@/mocks/movies';

const faqData = [
  {
    question: '成全影院的影片画质如何？',
    answer: '成全影院所有影片均采用高清编码技术，支持1080P全高清和4K蓝光画质。无论您是使用电脑、平板还是手机观看，都能享受到清晰细腻的视觉体验。我们采用先进的CDN加速技术，确保播放流畅不卡顿。',
  },
  {
    question: '成全影院是否需要付费？',
    answer: '成全影院完全免费！您无需支付任何费用即可在线观看所有电影和电视剧全集。我们致力于为用户提供优质的免费观影服务，没有任何隐藏收费项目。',
  },
  {
    question: '观看影片时会有广告吗？',
    answer: '成全影院承诺无广告干扰！在观影过程中，不会出现任何插播广告、弹窗广告或贴片广告，让您享受纯净的沉浸式观影体验。',
  },
  {
    question: '成全影院支持哪些设备？',
    answer: '成全影院支持所有主流设备，包括Windows和Mac电脑、iOS和Android手机平板、智能电视以及各种浏览器。只需打开浏览器访问成全影院，即可随时随地观看精彩影片。',
  },
  {
    question: '影片更新频率是怎样的？',
    answer: '成全影院每天更新最新电影和电视剧资源。我们的内容团队会第一时间上线新片，确保您不错过任何热门影视作品。通常新上映的影片会在48小时内上架。',
  },
  {
    question: '如何快速找到我想看的影片？',
    answer: '您可以通过首页的推荐板块浏览精选内容，也可以使用分类功能按类型筛选（动作、喜剧、爱情、科幻、恐怖、动画、剧情、悬疑）。我们的搜索功能也即将上线，届时可以更方便地查找影片。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-14">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm text-secondary-500">
            关于成全影院，您可能想了解的问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-secondary-400"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-secondary-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}